<template>
    <Interval
        :title="$t('day' + vara.number) + ' (' + vara.lord + ')'"
        :description="$t('sunrise') + ' ' + formatTime(vara.start)
          + ' / ' + $t('sunset') + ' ' + formatTime(vara.night)
          + ' / ' + $t('daylight') + ' ' + daylight"
        :bg="'bg-'+vara.lord.toLowerCase()" :favorable="vara.favorable"
        :start="vara.start" :length="vara.length"
        :scale="scale" :zero="zero" :visibleLeft="visibleLeft"
    />
</template>

<script>
import Interval from '@/components/panchanga/Interval'
import { TimeFormatMixin } from '@/components/visual/TimeFormatMixin'
export default {
  props: ['vara', 'scale', 'zero', 'visibleLeft'],
  components: { Interval },
  mixins: [TimeFormatMixin],
  computed: {
    daylight() {
      var minutes = Math.floor((this.vara.night - this.vara.start) / 60);
      var hours = Math.floor(minutes / 60);
      var minuteStr = '0' + (minutes - hours * 60)
      minuteStr = minuteStr.substr(minuteStr.length - 2)
      return hours + ':' + minuteStr
    }
  },
}
</script>

<i18n locale="ru" lang="yaml">
  sunrise: "Восход"
  sunset: "Закат"
  daylight: "Световой день"
  day1: "Воскресенье"
  day2: "Понедельник"
  day3: "Вторник"
  day4: "Среда"
  day5: "Четверг"
  day6: "Пятница"
  day7: "Суббота"
</i18n>

<i18n locale="en" lang="yaml">
  sunrise: "Sunrise"
  sunset: "Sunset"
  daylight: "Daylight"
  day1: "Sunday"
  day2: "Monday"
  day3: "Tuesday"
  day4: "Wednesday"
  day5: "Thursday"
  day6: "Friday"
  day7: "Saturday"
</i18n>
